import { Link } from 'react-router-dom';
import { duration, money, titleCase } from '../lib/format';

export interface CourseCardModel {
  id: string;
  title: string;
  slug: string;
  shortDescription: string;
  difficulty: string;
  durationMinutes: number;
  priceMinor: number;
  currency: string;
  isFree: boolean;
  rating: { average: number; count: number };
  category: { name: string; slug: string };
  instructors: string[];
  skills?: string[];
  thumbnailUrl: string | null;
}

/**
 * The catalog card answers four questions at a glance: what is it, how long,
 * how hard, how much. Anything that does not serve one of those is left off.
 */
export function CourseCard({ course }: { course: CourseCardModel }) {
  return (
    <Link className="ccard" to={`/courses/${course.slug}`}>
      <div className="ccard__media">
        {course.thumbnailUrl ? (
          <img src={course.thumbnailUrl} alt="" loading="lazy" />
        ) : (
          <span className="ccard__media-fallback">SKILLXZEN</span>
        )}
        <span className="ccard__lvl">{titleCase(course.difficulty)}</span>
      </div>

      <div className="ccard__body">
        <span className="ccard__cat">{course.category.name}</span>
        <h3 className="ccard__title">{course.title}</h3>
        <p className="ccard__desc">{course.shortDescription}</p>

        {course.skills && course.skills.length > 0 ? (
          <div className="ccard__tags">
            {course.skills.slice(0, 3).map((skill) => (
              <span className="pill pill--inactive" key={skill}>
                {skill}
              </span>
            ))}
          </div>
        ) : null}

        <div className="ccard__meta">
          <span>{duration(course.durationMinutes)}</span>
          {course.instructors[0] ? <span>{course.instructors[0]}</span> : null}
        </div>

        <div className="ccard__foot">
          <span className={`ccard__price${course.isFree ? ' ccard__price--free' : ''}`}>
            {course.isFree ? 'Free' : money(course.priceMinor, course.currency)}
          </span>
          {course.rating.count > 0 ? (
            <span className="rating">
              <span className="rating__star">★</span>
              {course.rating.average.toFixed(1)}
              <span className="muted">({course.rating.count})</span>
            </span>
          ) : (
            <span className="muted" style={{ font: 'var(--sx-caption)' }}>
              New
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
